import axios from 'axios';
import { ACTIVITY_LOG_URL, FORCE_ACTIVATION_URL } from 'api/constants';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function getLogs(group, item, page, size) {
  try {
    return await axios.get(ACTIVITY_LOG_URL, {
      params: {
        group,
        item,
        page,
        size,
      },
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function forceActivation(payload) {
  const body = { payload };
  const file = body.payload;

  const formData = new FormData();
  formData.append('csv', file);

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  try {
    return await axios.post(FORCE_ACTIVATION_URL, formData, config);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
